import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/utils";
import { Slot } from "./slot";

export interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof buttonWrapperVariants> {
	asChild?: boolean;
	innerClassName?: string;
}

const buttonWrapperVariants = cva("inline-flex items-stretch rounded-4xl p-0.25 pb-0.5", {
	variants: {
		variant: {
			dark: " bg-neutral-800",
			light: "bg-neutral-200",
		},
		size: {
			small: "h-8 md:h-10",
			large: "h-11 md:h-12",
		},
	},
	defaultVariants: {
		variant: "dark",
		size: "large",
	},
});
const buttonInnerVariants = cva(
	"inline-flex items-center justify-center rounded-4xl px-4 border border-b-0 bg-gradient-to-b w-full",
	{
		variants: {
			variant: {
				dark: "transition-colors border-neutral-700 from-neutral-900 to-neutral-700 text-white hover:from-neutral-800 hover:to-neutral-600 active:border-neutral-500",
				light:
					"border-neutral-50 from-neutral-200 to-neutral-50 text-neutral-800 hover:from-neutral-300 hover:to-neutral-100 active:border-neutral-200",
			},
			size: {
				small: "text-xs font-medium md:text-sm",
				large: "text-sm font-medium md:text-base",
			},
		},
		defaultVariants: {
			variant: "dark",
			size: "large",
		},
	},
);

export const Button = ({ children, variant, size, className, innerClassName, asChild }: ButtonProps) => {
	const Comp = asChild ? Slot : "button";
	return (
		<span className={cn(buttonWrapperVariants({ variant, size, className }))}>
			<Comp className={cn(buttonInnerVariants({ variant, size, className: innerClassName }))}>
				{children}
			</Comp>
		</span>
	);
};
